// extracted by mini-css-extract-plugin
export default {"div":"DeclaracionesJuradas_div__m6L5t","container":"DeclaracionesJuradas_container__D0iLM"};